import React from 'react'
import { Box, Stack } from '@mui/material'

interface EditableTypographyProps {
  htmlContent: string
}

export const EditableTypography: React.FC<EditableTypographyProps> = ({
  htmlContent,
}) => {
  return (
    <Stack p={1}>
      <Box
        sx={{
          '& p': { margin: 0 },
          '& .ql-size-small': { fontSize: '0.75em' },
          '& .ql-size-large': { fontSize: '1.5em' },
          '& .ql-size-huge': { fontSize: '2.5em' },
        }}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </Stack>
  )
}
